module.exports = __webpack_public_path__ + "img/jingzhunguanhuai.35ad2921.png";